export default "__VITE_ASSET__EkW88IL$__"